import useStore from '../../../../store';
import { LandlordBooking, TenantBooking } from '../../../../types/bookings';
import { StyledSection } from '../BookingInformation.styles';
import BookingTenantActions from './BookingTenantActions';

interface BookingActionsProps {
  booking: LandlordBooking | TenantBooking;
}

const BookingActions = ({ booking }: BookingActionsProps) => {
  const { user } = useStore(state => ({
    user: state.user,
  }));

  return (
    <>
      {user?.type === 'tenant' && (
        <StyledSection>
          <BookingTenantActions
            canShowUploadButton={
              !(booking as TenantBooking)?.documents_uploaded
            }
            booking_id={booking?.id}
            user_type={user?.type}
          />
        </StyledSection>
      )}
    </>
  );
};

export default BookingActions;
